<template>
   <div class="container-fluid  property mt-16 pt-5" >
       <vue-headful
            :title="listing.UnparsedAddress"
        />
        <Search />
   <div v-if="loading" class="loading text-center">
      <v-progress-linear :size="90" :width="7" color="#bc2025" indeterminate></v-progress-linear>
    </div>
    
    <div class="row justify-content-center">
        <div class="col-lg-11">
            <div class="border">
                <div class="pt-2">
                    <div class="px-3 float-right" style="margin-top:{-3rem; !important}">
                    
                    <h4 class="text-h4" v-if="listing.MlsStatus == 'Active'">
                    <span class="badge badge-pill badge-success">For Sale</span>
                  </h4>
                  <h4 class="text-h4" v-if="listing.MlsStatus == 'Pending'">
                    <span class="badge badge-pill badge-warning">Pending</span>
                  </h4>
                  <h4 class="text-h4" v-if="listing.MlsStatus == 'Pending - Taking Backups'">
                    <span class="badge badge-pill badge-warning">Pending - Taking Backup Offers</span>
                  </h4>        
                  <h4 class="text-h4" v-if="listing.MlsStatus == 'Active Under Contract'">
                    <span class="badge badge-pill badge-warning">Pending - Under Contract</span>
                  </h4>
                    </div>
                    <h2 class=" px-3">${{ formatPrice(listing.ListPrice) }}</h2>
                    <h3 class=" px-3">{{listing.StreetNumber}} {{listing.StreetName}} , {{listing.City}}, {{listing.StateOrProvince}} {{ listing.PostalCode }} </h3>
                    
                    <!-- <h5 class="float-right border-top px-3 pt-1"> {{listing.StreetNumber}} {{ listing.StreetName }}, {{listing.City}}</h5> -->
                    <div class="h5 px-3 pt-2" >
                        <span v-if="listing.BedroomsTotal > 0"><strong>{{ listing.BedroomsTotal }} Beds </strong> | </span>
                        
                        <!-- <br> -->
                        <span v-if="listing.BathroomsTotalInteger > 0 "><strong>{{ listing.BathroomsTotalInteger }} Baths  </strong>|&nbsp;</span>
                        
                        <span v-if="listing.LivingArea != null"><strong> {{ listing.LivingArea }} Sq.Ft.</strong></span>
                        <span v-else><strong>{{listing.LotSizeAcres}} Acres</strong></span>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-7 ">
             <vue-flux
                :options="vfOptions"
                :images="images"
                :transitions="vfTransitions"
                :captions="vfCaptions"
                ref="slider">

                <template v-slot:preloader>
                    <flux-preloader />
                </template>

                <template v-slot:caption>
                    <flux-caption />
                </template>

                <template v-slot:controls>
                    <flux-controls />
                </template>

                <template v-slot:pagination>
                    <flux-pagination />
                </template>

                <template v-slot:index>
                    <flux-index />
                </template>
            </vue-flux>
            <sub>Double Click to open in fullscreen</sub>
            <div class="d-flex justify-content-end"><p class="">Property Listed By: {{listing.ListAgentFullName}} - {{listing.ListOfficeName}}</p></div>
            
            <!-- <button class="btn btn-primary float-right" @click="$refs.slider.show('next')">NEXT</button> -->
            <div class="card mb-3 d-lg-none d-md-block" v-if="listing.PublicRemarks != null">
                <div class="card-header">
                    Description for {{listing.StreetNumber}} {{ listing.StreetName }}, {{listing.City}}, {{listing.StateOrProvince}} {{ listing.PostalCode }}
                </div>
                <div class="card-body">
                    {{ listing.PublicRemarks }}
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    Property Details
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6 col-xs-12">
                            <div class="row">
                                <div class="col">
                                    <label for=""><strong>MLS#</strong></label>
                                </div>
                                <div class="col">
                                    <span>{{listing.ListingId}}</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.BedroomsTotal > 0" >
                                <div class="col">
                                    <label for=""><strong>Bedrooms</strong></label>
                                </div>
                                <div class="col">
                                    <span>{{listing.BedroomsTotal}}</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.BathroomsTotalInteger > 0 ">
                                <div class="col">
                                    <label for=""><strong>Bathrooms</strong></label>
                                </div>
                                <div class="col">
                                    <span>{{listing.BathroomsFull}}</span>
                                    <span v-if="listing.BathroomsHalf > 0"> & {{listing.BathroomsHalf}} Half</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.LivingArea != null">
                                <div class="col">
                                    <label for=""><strong>Square Feet</strong></label>
                                </div>
                                <div class="col">
                                    <span>{{listing.LivingArea}} sq.ft.</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.LotSizeAcres != null">
                                <div class="col">
                                    <label for=""><strong>Lot Size</strong></label>
                                </div>
                                <div class="col">
                                    <span>{{listing.LotSizeAcres}} Acres</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.View != null">
                                <div class="col">
                                    <label for=""><strong>Views</strong></label>
                                </div>
                                <div class="col">
                                    <span v-for="view in listing.View" :key="view"> {{ view }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <div class="row">
                                <div class="col">
                                    <label for=""><strong>Property Type</strong></label>  
                                </div>
                                <div class="col">
                                    <span><span v-if="listing.PropertySubType != null"> {{ listing.PropertySubType }},</span><span> {{listing.PropertyType}}</span></span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.CountyOrParish">
                                <div class="col">
                                    <label for=""><strong>County</strong></label>  
                                </div>
                                <div class="col">
                                    <span> {{ listing.CountyOrParish}}</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.YearBuilt != null">
                                <div class="col">
                                    <label for=""><strong>Year Built</strong></label>  
                                </div>
                                <div class="col">
                                    <span> {{ listing.YearBuilt}}</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.SubdivisionName != null">
                                <div class="col">
                                    <label for=""><strong>Sub Division</strong></label>  
                                </div>
                                <div class="col">
                                    <span> {{ listing.SubdivisionName}}</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.Utilities != null">
                                <div class="col">
                                    <label for=""><strong>Utilities </strong></label>  
                                </div>
                                <div class="col">

                                    <span class="border mx-1" v-for="utility in listing.Utilities" :key="utility"> {{ utility }},</span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.WaterSource != null || listing.Sewer != null">
                                <div class="col">
                                    <label for=""><strong>Water/Sewer</strong></label>  
                                </div>
                                <div class="col">
                                    Water:<span class="border mx-1"  v-for="water in listing.WaterSource" :key="water"> {{water}}</span>
                                    <br>
                                    Sewer:<span class="border mx-1"  v-for="sewer in listing.Sewer" :key="sewer"> {{sewer}}</span>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <hr>
                            <h3>Detailed Information</h3>
                            <div class="row" v-if="listing.LotFeatures != ''">
                                <div class="col-6">
                                    <label for=""><strong>Lot Features</strong></label>
                                </div>
                                <div class="col-6">
                                    <span class="border mx-1" v-for="master in listing.LotFeatures" :key="master">{{master}} </span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.Flooring != ''">
                                <div class="col-6">
                                    <label for=""><strong>Flooring</strong></label>
                                </div>
                                <div class="col-6">
                                    <span class="border mx-1" v-for="master in listing.Flooring" :key="master">{{master}} </span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.InteriorFeatures != ''">
                                <div class="col-6">
                                    <label for=""><strong>Interior Features</strong></label>
                                </div>
                                <div class="col-6">
                                    <span class="border mx-1" v-for="master in listing.InteriorFeatures" :key="master">{{master}} </span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.Cooling != '' || listing.Heating != ''">
                                <div class="col-6">
                                    <label for=""><strong>Heating/Cooling</strong></label>
                                </div>
                                <div class="col-6">
                                    <span class="border mx-1" v-for="master in listing.Cooling" :key="master">{{master}} </span>
                                    <span class="border mx-1" v-for="master in listing.Heating" :key="master">{{master}} </span>
                                </div>
                            </div>
                            <div class="row" v-if="(listing.FireplacesTotal != 0 || listing.FireplacesTotal == null)">
                                <div class="col-6">
                                    <label for=""><strong>Fireplaces & Fireplace Features</strong></label>
                                </div>
                                <div class="col-6">
                                    <!-- <span class="border mx-1" v-for="master in listing.FireplacesTotal" :key="master">{{master}} </span> -->
                                    
                                    <span> Fireplaces {{ listing.FireplacesTotal}} - </span> <span v-if="listing.FireplacesTotal == null">None</span> 
                                    <span class="border mx-1" v-for="master in listing.FireplaceFeatures" :key="master">{{master}} </span>
                                </div>
                            </div>
                            <div class="row" v-if="listing.ConstructionMaterials != ''">
                                <div class="col-6">
                                    <label for=""><strong>Construction Materials</strong></label>
                                </div>
                                <div class="col-6">
                                    <span class="border mx-1" v-for="master in listing.ConstructionMaterials" :key="master">{{master}} </span>
                                    
                                </div>
                            </div>
                            <div class="row" v-if="listing.FoundationDetails != ''">
                                <div class="col-6">
                                    <label for=""><strong>Foundation Details</strong></label>
                                </div>
                                <div class="col-6">
                                    <span class="border mx-1" v-for="master in listing.FoundationDetails" :key="master">{{master}} </span>
                                    
                                </div>
                            </div>
                            
                            
                            
                            
                        </div>
                        <!-- @TODO: add farm and ranch detailed information -->
                        <div class="col-12" v-if="listing.PropertyType == 'Farm'">
                            <hr>
                            <h3>Farm Land </h3>
                            <div class="row" v-if="listing.ACTRIS_GrassAcres != null">
                                <div class="col-6">
                                    <label for=""><strong>Grass Acres</strong></label>
                                </div>
                                <div class="col-6">
                                    <!-- <span class="border mx-1" v-for="master in listing.FireplacesTotal" :key="master">{{master}} </span> -->
                                    <span> {{ listing.ACTRIS_GrassAcres}} Acres</span><br>
                                    
                                </div>
                            </div>
                            <div class="row" v-if="listing.ACTRIS_NumBarns != null">
                                <div class="col-6">
                                    <label for=""><strong># Barns</strong></label>
                                </div>
                                <div class="col-6">
                                    <!-- <span class="border mx-1" v-for="master in listing.FireplacesTotal" :key="master">{{master}} </span> -->
                                    <span> {{ listing.ACTRIS_NumBarns}}</span><br>
                                    
                                </div>
                            </div>
                            <div class="row" v-if="listing.ACTRIS_NumCorrals != null">
                                <div class="col-6">
                                    <label for=""><strong># Corrals</strong></label>
                                </div>
                                <div class="col-6">
                                    <!-- <span class="border mx-1" v-for="master in listing.FireplacesTotal" :key="master">{{master}} </span> -->
                                    <span> {{ listing.ACTRIS_NumCorrals}}</span><br>
                                    
                                </div>
                            </div>
                            <div class="row" v-if="listing.ACTRIS_NumofPonds != null">
                                <div class="col-6">
                                    <label for=""><strong># Ponds</strong></label>
                                </div>
                                <div class="col-6">
                                    <!-- <span class="border mx-1" v-for="master in listing.FireplacesTotal" :key="master">{{master}} </span> -->
                                    <span> {{ listing.ACTRIS_NumofPonds}}</span><br>
                                    
                                </div>
                            </div>
                            <div class="row" v-if="listing.ACTRIS_NumofWells != null">
                                <div class="col-6">
                                    <label for=""><strong># Wells</strong></label>
                                </div>
                                <div class="col-6">
                                    <!-- <span class="border mx-1" v-for="master in listing.FireplacesTotal" :key="master">{{master}} </span> -->
                                    <span> {{ listing.ACTRIS_NumofWells}}</span><br>
                                    
                                </div>
                            </div>
                            
                            <div class="row" v-if="listing.ACTRIS_NumSheds != null">
                                <div class="col-6">
                                    <label for=""><strong># Sheds</strong></label>
                                </div>
                                <div class="col-6">
                                    <!-- <span class="border mx-1" v-for="master in listing.FireplacesTotal" :key="master">{{master}} </span> -->
                                    <span> {{ listing.ACTRIS_NumSheds}}</span><br>
                                    
                                </div>
                            </div>
                            <div class="row" v-if="listing.ACTRIS_SoilType != ''">
                                <div class="col-6">
                                    <label for=""><strong>Soil Type</strong></label>
                                </div>
                                <div class="col-6">
                                    <span class="border mx-1" v-for="master in listing.ACTRIS_SoilType" :key="master">{{master}} </span>
                                </div>
                            </div>
                            
                            <div class="row" v-if="listing.ACTRIS_TillableAcres != null">
                                <div class="col-6">
                                    <label for=""><strong>Tillable Acres</strong></label>
                                </div>
                                <div class="col-6">
                                    <!-- <span class="border mx-1" v-for="master in listing.FireplacesTotal" :key="master">{{master}} </span> -->
                                    <span> {{ listing.ACTRIS_TillableAcres}} Acres</span><br>
                                    
                                </div>
                            </div>
                            <div class="row" v-if="listing.Fencing != ''">
                                <div class="col-6">
                                    <label for=""><strong>Fencing</strong></label>
                                </div>
                                <div class="col-6">
                                    <span class="border mx-1" v-for="master in listing.Fencing" :key="master">{{master}} </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <hr>
                            <h3>School Districts</h3>
                            <div class="row">
                                <div class="col-3">
                                    <label for=""><strong>School District</strong></label>
                                </div>
                                <div class="col-3">
                                    <span>{{listing.HighSchoolDistrict}}</span>
                                </div>
                                <div class="col-3">
                                    <label for=""><strong>High School</strong></label>
                                </div>
                                <div class="col-3">
                                    <span>{{listing.HighSchool}}</span>
                                </div>
                                <div class="col-3">
                                    <label for=""><strong>Middle School</strong></label>
                                </div>
                                <div class="col-3">
                                    <span>{{listing.MiddleOrJuniorSchool}}</span>
                                </div>
                                <div class="col-3">
                                    <label for=""><strong>Elementary School</strong></label>
                                </div>
                                <div class="col-3">
                                    <span>{{listing.ElementarySchool}}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-6 col-xs-6 col-sm-3 col-md-6 col-lg-3">
                            <label for="">Bedrooms</label>
                        </div>
                        <div class="col-6 col-xs-6 col-sm-3 col-md-6 col-lg-3">
                            <span>{{listing.BedroomsTotal}}</span>
                        </div>
                        <div class="col-6 col-xs-6 col-sm-3 col-md-6 col-lg-3">
                            <label for="">County</label>
                        </div>
                        <div class="col-6 col-xs-6 col-sm-3 col-md-6 col-lg-3">
                            <span>{{listing.ListingId}}</span>
                        </div>
                        <div class="col-6 col-xs-6 col-sm-3 col-md-6 col-lg-3">
                            <label for="">MLS</label>
                        </div>
                        <div class="col-6 col-xs-6 col-sm-3 col-md-6 col-lg-3">
                            <span>{{listing.ListingId}}</span>
                        </div> -->

                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            
            <div class="card d-none d-lg-block">
                <div class="card-header">
                    Description for {{listing.StreetNumber}} {{ listing.StreetName }}, {{listing.City}}, {{listing.StateOrProvince}} {{ listing.PostalCode }}
                </div>
                <div class="card-body">
                    {{ listing.PublicRemarks }}

                    <hr>
                    <h5>Directions</h5>
                    {{ listing.Directions }}
                    <hr>
                    <h5>Map</h5>
                    <iframe width="98%" height="350" frameborder="0" style="border:0" :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyCn0iUkvkQ3s4W0LBPcEzqBrpRT7IsGWy0&q='+listing.Latitude+','+listing.Longitude +'&zoom=16&maptype=satellite'" allowfullscreen="">
						</iframe>
                    <hr>
                    {{listing.ListAgentFullName}} - {{listing.ListOfficeName}}
                </div>
                
            </div>
            <br>
            <div class="card d-none d-lg-block">
                <div class="card-header">
                    Contact Agent!
                </div>
                <div class="card-body">
                    <form class="form-horizontal leadform" :id="`contactform`+listing.ListingId" name="commentform" method="post" action="" @submit="saveContactMessage">
                        <div class="form-group row">
                            <label for="fName" class="col-sm-4 control-label">First Name</label>
                            <div class="col-sm-8">
                                <input v-model="fName" type="text" name="fName" class="form-control" id="fName" placeholder="First Name" value="jonathan" required="">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="lName" class="col-sm-4 control-label">Last Name</label>
                            <div class="col-sm-8">
                                <input v-model="lName" type="text" name="lName" class="form-control" id="lName" placeholder="Last Name" value="odom" required="">                       
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="email" class="col-sm-4 control-label">Email</label>
                            <div class="col-sm-8">
                                <input v-model="email" type="email" name="email" class="form-control" id="email" placeholder="Email" value="" required="">     
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="phone" class="col-sm-4 control-label">Phone Number</label>
                            <div class="col-sm-8">
                                <input v-model="phone" type="text" name="phone" class="form-control" id="phone" value="" required="">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="msg" class="col-sm-4 control-label">Message</label>
                            <div class="col-sm-8">
                                <textarea v-model="msg" class="form-control" name="msg" id="msg" rows="3" required="">Testing contact form</textarea>
                            </div>
                        </div>
                            <input type="text" name="id" hidden="" value="">
                        <br>
                        <div class="form-group row">
                            <label for="" class="col-sm-4"></label>
                            <div class="">
                                <button class="btn btn-primary contactsubmit" id="" type="submit">Send Message!</button>
                                <!-- <input name="submit" type="submit" id="contactsubmit" value="Send Message" class="btn btn-primary"> -->
                            </div>
                        </div>
      

					</form>
                </div>
                
            </div>
            <br>
            <Suggested v-bind:suggested="suggested" />
        </div>
    </div>
   </div>
</template>

<script>

// import VueGallery from 'vue-gallery';
// import VueEasyLightbox from 'vue-easy-lightbox'
// import { tns } from "./node_modules/tiny-slider/src/tiny-slider"
import Suggested from "../components/Suggested.vue";
import Search from '../components/Search';
import {
   VueFlux,
   FluxCaption,
   FluxControls,
   FluxIndex,
   FluxPagination,
   FluxPreloader
} from 'vue-flux';
import axios from 'axios';
export default {
    name: "Property",
    data() {
        return {
            loading: true,
            listing: [],
            search: this.$route.query.mlsid,
            images:[],
            visible: false,
            index: 0,
            vfOptions: {
                autoplay: true,
                allowFullscreen: true,
                enableGestures: true,
                allowToSkipTransition: true
            },
            vfTransitions: [ 'zip' ],
            vfCaptions: [ ],
            fName: '',
            lName: '',
            email: '',
            phone: '',
            msg: '',
            gps: ""+this.Longitude+","+this.Latitude+"",
            suggested:[],
            accessURL: "https://api.bridgedataoutput.com/api/v2/actris/listings?access_token=c03d8edc2e18155f1d8d782866904cfa",
        }
    },
    components: {
      VueFlux,
      FluxCaption,
      FluxControls,
      FluxIndex,
      FluxPagination,
      FluxPreloader,
      Suggested,
      Search,
    },
    beforeCreate: function(){
    // "https://api.bridgedataoutput.com/api/v2/OData/abor/Property('a373bd1bbdf40a6d7202a88cd846a44c')"
    // https://api.bridgedataoutput.com/api/v2/OData/dataset_id/Properties(‘12345’)?access_token=access_token
      axios
      .get("https://api.bridgedataoutput.com/api/v2/actris/listings/"+this.$route.query.mlsid+"?access_token=c03d8edc2e18155f1d8d782866904cfa")
      .then(response => {
        console.log(response)
        this.listing = response.data.bundle
        // console.log(this.listing)
        this.findSimilar(this.listing);
        this.listing.Media.forEach(Media => {
            this.images.push(Media.MediaURL);
            this.vfCaptions.push(Media.ShortDescription)
            // console.log(Media)
        });
    
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
      
  },
  methods:{
      formatPrice(value) {
        let val = (value/1).toFixed(0).replace(',', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
      showImg (index) {
          this.index = index
          this.visible = true
        },
        showSingle() {
      this.imgs = 'http://via.placeholder.com/350x150'
      // or
      this.imgs = { title: 'this is a placeholder', src: 'http://via.placeholder.com/350x150' }
      this.show()
    },
    showMultiple() {
      this.imgs = ['http://via.placeholder.com/350x150', 'http://via.placeholder.com/350x150']
      // or
      this.imgs = [
        { title: 'test img', src: 'http://via.placeholder.com/350x150' },
        'http://via.placeholder.com/350x150'
      ]
      // allow mixing

      this.index = 1  // index of imgList
      this.show()
    },
    show() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
   
    saveContactMessage (e) {
        e.preventDefault()
        // const messagesRef = this.$firebaseDatabase.collection('contactform')
        // messagesRef.add(
        //   {
        //     name: this.fName +' '+ this.lName,
        //     phone: this.phone,
        //     email: this.email,
        //     message: this.msg,
        //     listing: this.listing,
        //     time: new Date(),
        //   },
        // )
        const name = this.fName +' '+ this.lName;
        const email = this.email;
        const phone = this.phone;
        const message = this.msg;
        const listing = this.listing;
        const time = new Date();
        console.log([{name, email, phone, message, listing, time}])
        // const contactInfo = {name, email, phone, message, listing}
        // const formData = new FormData();
        // formData.append('fName', this.fName);
        // formData.append('lName', this.lName);
        // formData.append('email', email);
        // formData.append('phone', phone);
        // formData.append('msg', message);
        // formData.append('listing', this.listing);
        // console.log(formData)
        axios({
            method: 'post',
            url:'https://lexingtontexasrealestate.com/private/contactsubmit.php',
            params:{
                fName: this.fName,
                lName: this.lName,
                phone: phone,
                email: email,
                msg: this.msg,
                listing: this.listing.ListingKey
            }
        })
        // axios.post('http://pudowens.test/private/contactsubmit.php',{
            
        // }
        // )
        .then(function(response){
            console.log(response.data)
        }).catch(function(error){
            console.log(error)
        })
        

        this.fName= ''
        this.lName=''
        this.phone=''
        this.email = ''
        this.msg = ''
        this.submitted = true
        this.snackbar = false
      },
      findSimilar(listing){
          console.log(listing)
            axios
            .get(this.accessURL+"&limit=5&near="+listing.Longitude+","+listing.Latitude+"&radius=15&BedroomsTotal.gte="+listing.BedroomsTotal+"&PropertyType="+listing.PropertyType+"")
            .then(response => {
                console.log(response)
                this.suggested = response.data.bundle
                this.total = response.data.total
                // console.log(this.total)
                console.log(this.suggested)
                Object.keys(this.suggested).forEach(keys =>{
                    if(this.suggested[keys].PhotosCount > 0){
                        // console.log(this.suggested[keys].Media)
                    }
                })
            })
            .catch(error => {
                console.log(error)
                this.errored = true
            })
            .finally(() => this.loading = false)
      }
  }
}
</script>

<style>
.image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }
</style>